module.exports = __webpack_public_path__ + "media/images/icon__point--text@3x-c04bb2cbc23bdf9773e6f525dbecf72d.png";